"use client";

import dynamic from "next/dynamic";

const CookieConsent = dynamic(
  () => import("@/components/ui/cookie-consent").then(mod => ({ default: mod.CookieConsent })),
  { ssr: false }
);

const GA4Provider = dynamic(
  () => import("@/components/ga4-provider").then(mod => ({ default: mod.GA4Provider })),
  { ssr: false }
);

// TES-1573: top-of-funnel page-view step. ssr:false + lazy keeps it off the
// hydration critical path; it only runs a single effect after mount.
const LandingViewTracker = dynamic(
  () =>
    import("@/components/analytics/landing-view-tracker").then(mod => ({
      default: mod.LandingViewTracker,
    })),
  { ssr: false }
);

const CmdKDialog = dynamic(
  () => import("@/components/ui/cmd-k-dialog").then(mod => ({ default: mod.CmdKDialog })),
  { ssr: false }
);

const MobileMiniPlayerDynamic = dynamic(
  () =>
    import("@/components/ui/tls/mobile-mini-player").then(mod => ({
      default: mod.MobileMiniPlayer,
    })),
  { ssr: false }
);

// The expanded "Now Playing" tray (full transport, ScrubBar, SignalTitle
// plate). Was built (wave2d-audio) but never mounted anywhere in the app;
// isExpanded had no reachable setter to true, so it rendered nothing. See
// components/ui/tls/mobile-mini-player.tsx's expand affordance for the trigger.
const MobileAudioPlayerDynamic = dynamic(
  () =>
    import("@/components/ui/mobile-audio-player").then(mod => ({
      default: mod.MobileAudioPlayer,
    })),
  { ssr: false }
);

// eslint-disable-next-line react-doctor/no-multi-comp -- intentional co-location of related lazy shell wrappers; splitting to separate files adds churn with no benefit
export function LazyMobileMiniPlayer() {
  return <MobileMiniPlayerDynamic />;
}

// eslint-disable-next-line react-doctor/no-multi-comp -- intentional co-location of related lazy shell wrappers
export function LazyMobileAudioPlayer() {
  return <MobileAudioPlayerDynamic />;
}

export function LazyLayoutShell() {
  return (
    <>
      <CookieConsent />
      <GA4Provider />
      <LandingViewTracker />
      <CmdKDialog />
    </>
  );
}
